import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    \n  padding: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 30px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    // margin-top: 140px;\n    margin-top: 40px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 65vh;\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Modal = styled.div(_templateObject(), media.smallScreen(_templateObject2()), media.extraSmallScreen(_templateObject3()));
export var Content = styled.div(_templateObject4(), function (props) {
  return props.toDelete && "width: 60%;\n    text-align: center;\n    margin: 0 auto;";
}, function (_ref) {
  var spacing = _ref.theme.spacing;
  return "1rem ".concat(spacing.gutter, " 1.8rem ").concat(spacing.gutter);
});